import React, { useState, useEffect, useCallback } from 'react';
import { CheckedIcon, UncheckedIcon } from './CheckboxIcons';

export type ValidPropCheckbox = {
    id: string;
    lbl: string;
    val: boolean | undefined;
};

export function validPropCheckboxVM(id: string, lbl?: string, val?: boolean | undefined): ValidPropCheckbox {
    return {
        id: id,
        lbl: !!lbl ? lbl : '',
        val,
    };
}

export type ValidCheckboxProps = {
    id: string;
    label: string;
    checked: boolean | undefined;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    alignLeft?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ValidCheckbox = ({
    id,
    label,
    checked,
    onChange,
    disabled,
    alignLeft = false,
}: ValidCheckboxProps): JSX.Element => {
    const [checkedState, setCheckedState] = useState<boolean>(checked ?? false);

    // Sync with external checked prop changes
    useEffect(() => {
        setCheckedState(checked ?? false);
    }, [checked]);

    const handleChange = useCallback((): void => {
        if (disabled) return;

        const newChecked = !checkedState;
        setCheckedState(newChecked);
        onChange(newChecked);
    }, [checkedState, onChange, disabled]);

    return (
        <div
            className={`component-valid-checkbox component-valid-input ${disabled ? 'disabled' : ''} ${alignLeft ? 'align-left' : ''}`}
            onClick={handleChange}
        >
            <div
                id={id}
                className="checkbox-icon-wrapper"
            >
                {checkedState ? (
                    <CheckedIcon className="checkbox-icon checked" />
                ) : (
                    <UncheckedIcon className="checkbox-icon unchecked" />
                )}
            </div>
            <label
                htmlFor={id}
                className="checkbox-label"
            >
                {label}
            </label>
        </div>
    );
};

export default ValidCheckbox;
